(function () {

    /** Fecha dropdowns de sugestão da busca; usado pelo Escape global (mobile). */
    var terraforteCloseSearchSuggestIfOpen = function () { return false; };

    // ─── Botões de quantidade (+/-) ───────────────────────────────────────────

    function initQtyButtons() {
        document.querySelectorAll('.qty-btn').forEach(function (btn) {
            if (btn.dataset.qtyBound) return;
            btn.dataset.qtyBound = '1';

            btn.addEventListener('click', function () {
                const wrapper = btn.closest('.quantity');
                if (!wrapper) return;

                const input = wrapper.querySelector('input.qty');
                if (!input) return;

                const step  = parseFloat(input.step)  || 1;
                const min   = parseFloat(input.min)   || 0;
                const max   = input.max !== '' ? parseFloat(input.max) : Infinity;
                let value   = parseFloat(input.value) || 0;

                if (btn.classList.contains('qty-btn--plus')) {
                    value = Math.min(value + step, max);
                } else {
                    value = Math.max(value - step, min);
                }

                input.value = value;

                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.dispatchEvent(new Event('input',  { bubbles: true }));
            });
        });
    }

    // ─── Hover cumulativo nas estrelas do formulário de avaliação ─────────────
    // O WooCommerce cria <p class="stars"><a class="star-1">texto</a>...</p>
    // e gerencia o click (class .active). Aqui adicionamos só o hover.

    function initStarHover() {
        document.querySelectorAll('p.stars span').forEach(function (span) {
            if (span.dataset.hoverBound) return;
            span.dataset.hoverBound = '1';

            const links = Array.from(span.querySelectorAll('a'));

            links.forEach(function (link, idx) {
                link.addEventListener('mouseenter', function () {
                    links.forEach(function (l, i) {
                        l.classList.toggle('hovered', i <= idx);
                    });
                });

                link.addEventListener('mouseleave', function () {
                    links.forEach(function (l) { l.classList.remove('hovered'); });
                });
            });
        });
    }

    // ─── Seções de tabs do produto ────────────────────────────────────────────
    // Descrição e outros painéis: título visível, conteúdo sempre expandido.
    // Reviews: único painel colapsável (card com toggle).

    function initCollapsibleTabs() {
        // Lê títulos do nav oculto (.wc-tabs) e mapeia por id do painel
        const titleMap = {};
        document.querySelectorAll('.wc-tabs li a').forEach(function (link) {
            const id = (link.getAttribute('href') || '').replace('#', '');
            if (id) titleMap[id] = link.textContent.trim();
        });

        document.querySelectorAll('.woocommerce-tabs .wc-tab').forEach(function (panel) {
            if (panel.dataset.collapsibleBound) return;
            panel.dataset.collapsibleBound = '1';

            // Reutiliza o h2 já gerado pelo WooCommerce (descrição, informações adicionais…)
            // Só injeta um novo quando não existe h2 filho direto — caso do painel de reviews
            let heading = panel.querySelector(':scope > h2');
            if (!heading) {
                heading = document.createElement('h2');
                heading.textContent = titleMap[panel.id] || '';
                panel.prepend(heading);
            }

            // Apenas o painel de avaliações é colapsável
            if (panel.id !== 'tab-reviews') return;

            // Envolve o conteúdo do reviews em .wc-tab__content > .wc-tab__inner
            const inner   = document.createElement('div');
            inner.className = 'wc-tab__inner';

            const content = document.createElement('div');
            content.className = 'wc-tab__content';

            Array.from(panel.children).forEach(function (child) {
                if (child !== heading) inner.appendChild(child);
            });

            content.appendChild(inner);
            panel.appendChild(content);

            heading.addEventListener('click', function () {
                const isOpen = panel.classList.toggle('is-open');
                content.style.maxHeight = isOpen ? inner.scrollHeight + 'px' : '0';
            });
        });
    }

    // ─── Layout 50/50 quando há só uma imagem (sem galeria) ──────────────────
    // O WC JS desativa o Flexslider para 1 imagem: não cria .flex-control-thumbs,
    // então :has() no CSS não funciona. Adicionamos classe via JS.

    function initSingleImageLayout() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery) return;

        const images = gallery.querySelectorAll('.woocommerce-product-gallery__image');
        if (images.length === 1) {
            const product = gallery.closest('.product');
            if (product) product.classList.add('has-single-image');
        }
    }

    // ─── Overlay "+N" na 6ª posição (5 thumbnails livres + 1 ação) ────────────
    // Roda após o Flexslider criar os .flex-control-thumbs li

    function initGalleryMoreOverlay() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery) return;

        const FREE = 4; // thumbnails completamente livres; o 5º slot (idx 4) vira overlay
        const images = gallery.querySelectorAll('.woocommerce-product-gallery__image');
        if (images.length <= 5) return; // ≤5 imagens: todas visíveis, sem overlay

        const extra = images.length - FREE;
        const thumbItems = gallery.querySelectorAll('.flex-control-thumbs li');
        const actionThumb = thumbItems[FREE]; // 5ª posição (idx 4)
        if (!actionThumb || actionThumb.querySelector('.gallery-more-overlay')) return;

        const overlay = document.createElement('div');
        overlay.className   = 'gallery-more-overlay';
        overlay.textContent = '+' + extra;
        overlay.setAttribute('role', 'button');
        overlay.setAttribute('aria-label', 'Ver todas as imagens');

        actionThumb.appendChild(overlay);

        overlay.addEventListener('click', function (e) {
            e.stopPropagation();
            const trigger = gallery.querySelector('.woocommerce-product-gallery__trigger');
            if (trigger) trigger.click();
        });
    }

    // ─── Sincroniza altura dos thumbnails com a imagem em destaque ────────────
    // Calcula a altura de cada thumbnail para que 5 deles (+ gaps) = viewportH.
    // Aplica inline em cada li e define max-height da coluna = viewportH.

    function initThumbsMaxHeight() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery) return;

        const viewport = gallery.querySelector('.flex-viewport');
        const thumbs   = gallery.querySelector('.flex-control-thumbs');
        if (!viewport || !thumbs) return;

        if (gallery.dataset.thumbsHeightBound === '1') {
            if (typeof gallery._tfThumbsScheduleSync === 'function') {
                gallery._tfThumbsScheduleSync();
            }
            return;
        }

        gallery.dataset.thumbsHeightBound = '1';

        const MAX_VISIBLE = 5;
        let syncFrame = null;

        function sync() {
            syncFrame = null;

            const viewportH = viewport.getBoundingClientRect().height || viewport.offsetHeight;
            if (viewportH <= 0) return;

            const gap    = parseFloat(getComputedStyle(thumbs).rowGap) || 8;
            const thumbH = Math.max((viewportH - gap * (MAX_VISIBLE - 1)) / MAX_VISIBLE, 0);

            thumbs.querySelectorAll('li').forEach(function (li) {
                li.style.height = thumbH + 'px';
            });

            thumbs.style.maxHeight = viewportH + 'px';
        }

        function scheduleSync() {
            if (syncFrame !== null) cancelAnimationFrame(syncFrame);
            syncFrame = requestAnimationFrame(sync);
        }

        function scheduleSettledSync() {
            scheduleSync();
            setTimeout(scheduleSync, 80);
            setTimeout(scheduleSync, 220);
        }

        gallery._tfThumbsScheduleSync = scheduleSettledSync;

        scheduleSettledSync();
        window.addEventListener('resize', scheduleSync);
        window.addEventListener('load', scheduleSettledSync, { once: true });

        viewport.querySelectorAll('img').forEach(function (img) {
            if (img.complete) return;
            img.addEventListener('load', scheduleSettledSync, { once: true });
        });

        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(scheduleSync);
            resizeObserver.observe(viewport);
            gallery._tfThumbsResizeObserver = resizeObserver;
        }
    }

    // ─── Clique em qualquer ponto da viewport abre o lightbox ────────────────
    // O trigger fica invisível; o clique em toda a .flex-viewport é redirecionado
    // para trigger.click() que o WC JS já tem vinculado ao openPhotoswipe.
    // Para imagem única (sem .flex-viewport) o WC JS já vincula a <a> diretamente.

    function initGalleryImageClick() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery || gallery.dataset.imgClickBound) return;
        gallery.dataset.imgClickBound = '1';

        const viewport = gallery.querySelector('.flex-viewport');
        if (!viewport) return; // imagem única: WC JS já gerencia o clique nativamente

        viewport.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const trigger = gallery.querySelector('.woocommerce-product-gallery__trigger');
            if (trigger) trigger.click();
        }, true); // capture phase: antes dos handlers do WC
    }

    // ─── Aguarda o Flexslider do WooCommerce injetar a galeria ─────────────────
    // O WC JS injeta .flex-viewport e .flex-control-thumbs de forma assíncrona
    // após o DOMContentLoaded. Em vez de setTimeout (tempo fixo e instável),
    // usamos MutationObserver para disparar exatamente quando os elementos
    // estiverem presentes no DOM.

    function initGalleryWhenReady() {
        const gallery = document.querySelector('.woocommerce-product-gallery');
        if (!gallery) return; // não é página de produto

        let observer = null; // declarado no escopo externo para tryInit poder acessá-lo

        // Verifica se o Flexslider já renderizou e inicializa tudo
        function tryInit() {
            const viewport = gallery.querySelector('.flex-viewport');
            const thumbs   = gallery.querySelector('.flex-control-thumbs');

            // Para imagem única: viewport e thumbs não existem — OK inicializar já
            const isSingleImage = gallery.querySelectorAll(
                '.woocommerce-product-gallery__image'
            ).length === 1;

            if ( isSingleImage || (viewport && thumbs) ) {
                // Flexslider pronto — inicializa tudo
                initGalleryImageClick();
                initGalleryMoreOverlay();
                initThumbsMaxHeight();

                if (observer) { observer.disconnect(); observer = null; }
                return true;
            }
            return false;
        }

        // Tenta imediatamente (caso o WC já tenha terminado antes do nosso listener)
        if (tryInit()) return;

        // Observa o gallery até que .flex-viewport e .flex-control-thumbs apareçam
        observer = new MutationObserver(function () { tryInit(); });
        observer.observe(gallery, { childList: true, subtree: true });

        // Safety: desconecta após 5 s para não vazar memória em caso de falha do WC
        setTimeout(function () {
            if (observer) {
                observer.disconnect();
                observer = null;
                tryInit(); // última tentativa
            }
        }, 5000);
    }

    // ─── Init ─────────────────────────────────────────────────────────────────

    document.addEventListener('DOMContentLoaded', function () {
        initQtyButtons();
        initCollapsibleTabs();
        initStarHover();
        initSingleImageLayout();
        initGalleryWhenReady();
    });

    document.body.addEventListener('updated_wc_div',  initQtyButtons);
    document.body.addEventListener('wc_cart_emptied', initQtyButtons);

    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on(
            'updated_cart_totals updated_checkout wc-blocks-checkout:update',
            initQtyButtons
        );
    }

    // ─── Dropdown do header (contato) ─────────────────────────────────────────

    function initHeaderDropdown() {
        document.querySelectorAll('.hdr-dropdown').forEach(function (dropdown) {
            var trigger = dropdown.querySelector('.hdr-dropdown__trigger');
            var panel   = dropdown.querySelector('.hdr-dropdown__panel');
            if (!trigger || !panel) return;
            if (trigger.dataset.dropdownBound) return;
            trigger.dataset.dropdownBound = '1';

            trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                var isOpen = panel.classList.toggle('is-open');
                trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });

            // Trigger sem <button> (ex.: conta com avatar): Enter / Espaço abrem o painel
            if (trigger.tagName !== 'BUTTON' && trigger.getAttribute('role') === 'button') {
                trigger.addEventListener('keydown', function (e) {
                    if (e.key !== 'Enter' && e.key !== ' ') return;
                    e.preventDefault();
                    trigger.click();
                });
            }
        });

        // Fecha ao clicar fora
        document.addEventListener('click', function () {
            document.querySelectorAll('.hdr-dropdown__panel.is-open').forEach(function (panel) {
                panel.classList.remove('is-open');
                var trigger = panel.closest('.hdr-dropdown');
                if (trigger) {
                    var btn = trigger.querySelector('.hdr-dropdown__trigger');
                    if (btn) btn.setAttribute('aria-expanded', 'false');
                }
            });
        });

        // Fecha ao pressionar Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                document.querySelectorAll('.hdr-dropdown__panel.is-open').forEach(function (panel) {
                    panel.classList.remove('is-open');
                    var dropdown = panel.closest('.hdr-dropdown');
                    if (dropdown) {
                        var btn = dropdown.querySelector('.hdr-dropdown__trigger');
                        if (btn) {
                            btn.setAttribute('aria-expanded', 'false');
                            btn.focus();
                        }
                    }
                });
            }
        });
    }

    initHeaderDropdown();

    // ─── Toasts WooCommerce — canto inferior direito, empilhados, auto-close 60s ─
    // Preserva botões de ação do WooCommerce (ex: "Ver carrinho")

    var NOTICE_ICONS = {
        success: 'check-circle',
        error:   'alert-circle',
        info:    'info',
        warning: 'alert-triangle',
    };

    var TOAST_AUTO_CLOSE_MS = 60000;

    function getNoticeStack() {
        var stack = document.querySelector('.tf-notice-stack');
        if (stack) return stack;

        stack = document.createElement('div');
        stack.className = 'tf-notice-stack tf-notice-stack--toast';
        stack.setAttribute('aria-label', 'Avisos');
        stack.setAttribute('aria-live', 'polite');
        document.body.appendChild(stack);
        return stack;
    }

    function dismissNotice(notice) {
        if (!notice || !notice.parentNode) return;
        if (notice._tfAutoCloseTimer) {
            clearTimeout(notice._tfAutoCloseTimer);
            notice._tfAutoCloseTimer = null;
        }
        notice.classList.add('tf-notice--closing');
        notice.addEventListener('animationend', function () {
            notice.remove();
            var s = document.querySelector('.tf-notice-stack');
            if (s && !s.children.length) s.remove();
        }, { once: true });
    }

    function showNotice(msg, type, actionHtml) {
        var stack = getNoticeStack();
        var icon  = NOTICE_ICONS[type] || 'info';

        var existing = stack.querySelectorAll('.tf-notice__text');
        for (var i = 0; i < existing.length; i++) {
            if (existing[i].textContent.trim() === msg.trim()) return;
        }

        var notice = document.createElement('div');
        notice.className = 'tf-notice tf-notice--toast tf-notice--' + (type || 'info');
        notice.setAttribute('role', 'alert');

        var iconEl = document.createElement('span');
        iconEl.className = 'tf-notice__icon';
        iconEl.innerHTML = '<i data-lucide="' + icon + '" aria-hidden="true"></i>';

        var body = document.createElement('div');
        body.className = 'tf-notice__body';

        var textEl = document.createElement('span');
        textEl.className = 'tf-notice__text';
        textEl.textContent = msg;
        body.appendChild(textEl);

        if (actionHtml) {
            var wrap = document.createElement('span');
            wrap.innerHTML = actionHtml;
            var actionLink = wrap.querySelector('a, button');
            if (actionLink) {
                actionLink.className = (actionLink.className + ' tf-notice__action').trim();
                body.appendChild(actionLink);
            }
        }

        var closeBtn = document.createElement('button');
        closeBtn.className = 'tf-notice__close';
        closeBtn.type      = 'button';
        closeBtn.setAttribute('aria-label', 'Fechar aviso');
        closeBtn.innerHTML = '<i data-lucide="x" aria-hidden="true"></i>';

        closeBtn.addEventListener('click', function () {
            dismissNotice(notice);
        });

        notice.appendChild(iconEl);
        notice.appendChild(body);
        notice.appendChild(closeBtn);
        stack.appendChild(notice);

        notice._tfAutoCloseTimer = setTimeout(function () {
            dismissNotice(notice);
        }, TOAST_AUTO_CLOSE_MS);

        if (window.lucide) window.lucide.createIcons();
    }

    /**
     * Aviso “sem métodos de pagamento” vem de #payment; move para cima do cupom, fixo na página.
     */
    function terraforteRelocateCheckoutPaymentNotices() {
        if (!document.body.classList.contains('woocommerce-checkout')) {
            return;
        }
        var toggle = document.querySelector('.woocommerce-form-coupon-toggle');
        var checkoutForm = document.querySelector('form.checkout.woocommerce-checkout');
        var insertParent = null;
        var insertBefore = null;
        if (toggle && toggle.parentNode) {
            insertParent = toggle.parentNode;
            insertBefore = toggle;
        } else if (checkoutForm && checkoutForm.parentNode) {
            insertParent = checkoutForm.parentNode;
            insertBefore = checkoutForm;
        } else {
            return;
        }
        var host = document.getElementById('tf-checkout-persistent-notices');
        if (!host) {
            host = document.createElement('div');
            host.id = 'tf-checkout-persistent-notices';
            host.className = 'tf-checkout-persistent-notices';
            host.setAttribute('role', 'region');
            host.setAttribute('aria-label', 'Avisos do checkout');
            insertParent.insertBefore(host, insertBefore);
        }
        var payment = document.querySelector('#payment');
        if (!payment) {
            return;
        }
        function tfNoticeText(node) {
            return (node.textContent || '').replace(/\s+/g, ' ').trim();
        }
        var sel = '.wc_payment_methods > li > .woocommerce-info, .wc_payment_methods > li > .woocommerce-message, .wc_payment_methods > li > .woocommerce-error';
        var nodes = Array.prototype.slice.call(payment.querySelectorAll(sel));
        var seenInPayment = {};
        nodes.forEach(function (el) {
            if (el.closest('#tf-checkout-persistent-notices')) {
                return;
            }
            var t = tfNoticeText(el);
            if (!t) {
                return;
            }
            // Mesmo texto várias vezes em #payment (ex.: re-render): mantém um só
            if (seenInPayment[t]) {
                el.remove();
                return;
            }
            seenInPayment[t] = true;
            // updated_checkout recria #payment; remove cópia antiga já no host
            host.querySelectorAll('.woocommerce-info, .woocommerce-message, .woocommerce-error').forEach(function (old) {
                if (old.parentNode === host && tfNoticeText(old) === t) {
                    old.remove();
                }
            });
            host.appendChild(el);
        });
    }

    // Converte um elemento de notice WC em toast
    function convertNoticeToToast(el) {
        if (el.dataset.tfConverted) return;

        // Mantém avisos na Minha conta no conteúdo (não converter em toast)
        if (el.closest('.my-account-content') || el.closest('.woocommerce-MyAccount-content')) {
            return;
        }

        // Checkout: avisos ficam na página (ex.: sem gateway na região), não em toast
        if (document.body.classList.contains('woocommerce-checkout')) {
            return;
        }

        el.dataset.tfConverted = '1';

        // Ignora componentes interativos internos
        if (el.closest('.woocommerce-form-coupon-toggle')) return;

        var type = 'info';
        if (el.classList.contains('woocommerce-message')) type = 'success';
        if (el.classList.contains('woocommerce-error'))   type = 'error';
        if (el.classList.contains('woocommerce-info'))    type = 'info';

        // Extrai botão de ação se existir
        var clone     = el.cloneNode(true);
        var actionBtn = clone.querySelector('a.button, .wc-forward');
        var actionHtml = actionBtn ? actionBtn.outerHTML : null;

        // Remove botões para extrair texto limpo
        clone.querySelectorAll('a.button, .button, .wc-forward').forEach(function (b) { b.remove(); });
        var text = (clone.textContent || '').trim().replace(/\s+/g, ' ');
        if (!text) return;

        el.style.setProperty('display', 'none', 'important');
        showNotice(text, type, actionHtml);
    }

    // Processa notices já no DOM (server-side)
    // Usa seletor único para evitar selecionar o mesmo elemento duas vezes
    function processExistingNotices() {
        var sel = '.woocommerce-message, .woocommerce-error, .woocommerce-info';
        document.querySelectorAll(sel).forEach(convertNoticeToToast);
    }

    // Remove todos os banners ativos (usado antes de re-processar após AJAX)
    function clearNoticeStack() {
        var stack = document.querySelector('.tf-notice-stack');
        if (stack) stack.remove();
    }

    // Observa notices injetadas via AJAX
    function initNoticeObserver() {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return;

                    if (
                        node.classList.contains('woocommerce-message') ||
                        node.classList.contains('woocommerce-error') ||
                        node.classList.contains('woocommerce-info')
                    ) {
                        convertNoticeToToast(node);
                    }

                    if (node.querySelectorAll) {
                        node.querySelectorAll(
                            '.woocommerce-message, .woocommerce-error, .woocommerce-info'
                        ).forEach(convertNoticeToToast);
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    function initWooNotices() {
        processExistingNotices();
        initNoticeObserver();

        if (document.body.classList.contains('woocommerce-checkout')) {
            setTimeout(terraforteRelocateCheckoutPaymentNotices, 0);
        }

        if (typeof jQuery !== 'undefined') {
            // Fallback: se o WC não injetar notice HTML no add-to-cart
            jQuery(document.body).on('added_to_cart', function () {
                setTimeout(function () {
                    var hasNew = document.querySelector('.woocommerce-message:not([data-tf-converted])');
                    if (!hasNew) showNotice('Produto adicionado ao carrinho!', 'success');
                }, 150);
            });

            // Checkout AJAX: limpa toasts antes do WC reinjetar as notices
            jQuery(document.body).on('updated_checkout', function () {
                clearNoticeStack();
                setTimeout(function () {
                    processExistingNotices();
                    terraforteRelocateCheckoutPaymentNotices();
                }, 80);
            });
        }
    }

    document.addEventListener('DOMContentLoaded', initWooNotices);



    // ─── Formulário de cupom: layout inline + botão fechar ────────────────────

    function initCouponForm() {
        var form = document.querySelector('.woocommerce-form-coupon');
        if (!form || form.dataset.couponBound) return;
        form.dataset.couponBound = '1';

        // Reagrupa input + botão "Aplicar cupom" em .coupon-inline
        var input  = form.querySelector('input[name="coupon_code"]');
        var button = form.querySelector('[name="apply_coupon"]');
        if (input && button) {
            var wrapper = document.createElement('div');
            wrapper.className = 'coupon-inline';
            input.parentNode.insertBefore(wrapper, input);
            wrapper.appendChild(input);
            wrapper.appendChild(button);
        }

        // Botão X para fechar o formulário
        var closeBtn = document.createElement('button');
        closeBtn.type      = 'button';
        closeBtn.className = 'coupon-close';
        closeBtn.innerHTML = '&times;';
        closeBtn.setAttribute('aria-label', 'Fechar formulário de cupom');
        form.appendChild(closeBtn);

        closeBtn.addEventListener('click', function () {
            form.style.display = 'none';
        });
    }

    document.addEventListener('DOMContentLoaded', initCouponForm);

    // Re-init após atualização do checkout (AJAX)
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('updated_checkout', initCouponForm);
    }

    // Após o WC atualizar fragments, re-init ícones Lucide
    if (typeof jQuery !== 'undefined') {
        jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', function () {
            if (typeof window.lucide !== 'undefined' && typeof window.lucide.createIcons === 'function') {
                window.lucide.createIcons();
            }
        });
    }

    // ─── Busca: sugestões (produtos via REST) ─────────────────────────────────

    function initHeaderSearchSuggest() {
        var cfg = typeof window.terraforteSearch === 'undefined' ? null : window.terraforteSearch;
        if (!cfg || !cfg.restUrl) return;

        var minChars = parseInt(String(cfg.minChars || '2'), 10) || 2;
        var perPage  = parseInt(String(cfg.perPage || '8'), 10) || 8;
        var i18n     = cfg.i18n || {};

        function escapeHtml(str) {
            var d = document.createElement('div');
            d.textContent = str;
            return d.innerHTML;
        }

        function escapeRe(s) {
            return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        function highlightTitle(title, q) {
            var esc = escapeHtml(title);
            var qt  = q.trim();
            if (!qt) return esc;
            try {
                var re = new RegExp('(' + escapeRe(qt) + ')', 'gi');
                return esc.replace(re, '<mark class="header-search-suggest__hl">$1</mark>');
            } catch (err) {
                return esc;
            }
        }

        function setMobileSuggestTall(combo, on) {
            var panel = document.getElementById('header-search-panel');
            if (!panel || !panel.contains(combo)) return;
            panel.classList.toggle('header-search-panel--suggest', !!on);
        }

        function hideSuggest(combo) {
            var input = combo.querySelector('.search-field');
            var box   = combo.querySelector('.header-search-suggest');
            if (!box) return;
            combo.classList.remove('is-suggest-open');
            setMobileSuggestTall(combo, false);
            box.hidden = true;
            box.innerHTML = '';
            if (input) {
                input.setAttribute('aria-expanded', 'false');
                input.removeAttribute('aria-activedescendant');
            }
            combo._tfSuggestActive = -1;
            if (combo._tfSuggestAbort) {
                combo._tfSuggestAbort.abort();
                combo._tfSuggestAbort = null;
            }
        }

        terraforteCloseSearchSuggestIfOpen = function () {
            var nodes = document.querySelectorAll('.header-search-combobox.is-suggest-open');
            if (!nodes.length) return false;
            nodes.forEach(function (c) { hideSuggest(c); });
            return true;
        };

        function renderLoading(box) {
            var p = document.createElement('p');
            p.className = 'header-search-suggest__status';
            p.textContent = i18n.loading || '';
            box.innerHTML = '';
            box.appendChild(p);
        }

        function renderItems(combo, input, box, items, q, form) {
            box.innerHTML = '';
            if (!items.length) {
                var empty = document.createElement('p');
                empty.className = 'header-search-suggest__status';
                empty.textContent = i18n.noHits || '';
                box.appendChild(empty);
            } else {
                items.forEach(function (it, idx) {
                    var a = document.createElement('a');
                    a.href = it.url;
                    a.className = 'header-search-suggest__item';
                    a.setAttribute('role', 'option');
                    a.id = box.id + '-opt-' + idx;
                    a.innerHTML = highlightTitle(it.title, q);
                    box.appendChild(a);
                });

                var foot = document.createElement('div');
                foot.className = 'header-search-suggest__footer';
                var viewAll = document.createElement('a');
                viewAll.className = 'header-search-suggest__view-all';
                viewAll.setAttribute('role', 'option');
                viewAll.id = box.id + '-opt-all';
                try {
                    var u = new URL(form.getAttribute('action') || '/', window.location.origin);
                    u.searchParams.set('s', q);
                    viewAll.href = u.toString();
                } catch (err) {
                    viewAll.href = '/?s=' + encodeURIComponent(q);
                }
                viewAll.textContent = i18n.viewAll || '';
                foot.appendChild(viewAll);
                box.appendChild(foot);
            }

            combo.classList.add('is-suggest-open');
            box.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            setMobileSuggestTall(combo, true);
            combo._tfSuggestActive = -1;
        }

        function getOptions(box) {
            return box.querySelectorAll('[role="option"]');
        }

        function setActive(combo, input, box, index) {
            var opts = getOptions(box);
            if (!opts.length) return;
            var i = index;
            if (i < 0) i = opts.length - 1;
            if (i >= opts.length) i = 0;
            combo._tfSuggestActive = i;
            opts.forEach(function (el, j) {
                el.classList.toggle('header-search-suggest__item--active', j === i);
            });
            var cur = opts[i];
            if (cur && cur.id) input.setAttribute('aria-activedescendant', cur.id);
        }

        document.querySelectorAll('.header-search-combobox').forEach(function (combo) {
            if (combo.dataset.tfSuggestBound) return;
            combo.dataset.tfSuggestBound = '1';

            var form  = combo.querySelector('.search-form');
            var input = combo.querySelector('.search-field');
            var box   = combo.querySelector('.header-search-suggest');
            if (!form || !input || !box) return;

            combo._tfSuggestActive = -1;
            var debounceTimer = null;

            function runFetch() {
                var q = (input.value || '').trim();
                if (q.length < minChars) {
                    hideSuggest(combo);
                    return;
                }

                if (combo._tfSuggestAbort) {
                    combo._tfSuggestAbort.abort();
                }
                var ctrl = new AbortController();
                combo._tfSuggestAbort = ctrl;

                renderLoading(box);
                combo.classList.add('is-suggest-open');
                box.hidden = false;
                setMobileSuggestTall(combo, true);
                input.setAttribute('aria-expanded', 'true');

                var url = cfg.restUrl + (cfg.restUrl.indexOf('?') >= 0 ? '&' : '?') +
                    'q=' + encodeURIComponent(q) +
                    '&per_page=' + encodeURIComponent(String(perPage));

                fetch(url, { signal: ctrl.signal, credentials: 'same-origin' })
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        var items = data && data.items ? data.items : [];
                        renderItems(combo, input, box, items, q, form);
                    })
                    .catch(function (err) {
                        if (err.name === 'AbortError') return;
                        hideSuggest(combo);
                    })
                    .finally(function () {
                        if (combo._tfSuggestAbort === ctrl) {
                            combo._tfSuggestAbort = null;
                        }
                    });
            }

            function scheduleFetch() {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(runFetch, 280);
            }

            input.addEventListener('input', scheduleFetch);
            input.addEventListener('focus', function () {
                var q = (input.value || '').trim();
                if (q.length >= minChars) scheduleFetch();
            });

            form.addEventListener('submit', function () {
                hideSuggest(combo);
            });

            input.addEventListener('blur', function () {
                setTimeout(function () {
                    if (!combo.contains(document.activeElement)) {
                        hideSuggest(combo);
                    }
                }, 200);
            });

            box.addEventListener('mousedown', function (e) {
                if (e.target.closest('a')) e.preventDefault();
            });

            input.addEventListener('keydown', function (e) {
                if (box.hidden) return;
                var opts = getOptions(box);
                if (!opts.length) return;

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    var next = combo._tfSuggestActive;
                    if (next < 0) next = 0;
                    else next += 1;
                    setActive(combo, input, box, next);
                    return;
                }
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    var prev = combo._tfSuggestActive;
                    if (prev < 0) prev = opts.length - 1;
                    else prev -= 1;
                    setActive(combo, input, box, prev);
                    return;
                }
                if (e.key === 'Enter' && combo._tfSuggestActive >= 0) {
                    var cur = opts[combo._tfSuggestActive];
                    if (cur && cur.getAttribute('href')) {
                        e.preventDefault();
                        window.location.href = cur.href;
                    }
                }
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    hideSuggest(combo);
                }
            });
        });
    }

    // ─── Busca mobile (toggle ícone → painel expansível) ──────────────────────

    function initMobileSearch() {
        var toggleBtn = document.getElementById('hdr-search-toggle');
        var panel     = document.getElementById('header-search-panel');

        if (!toggleBtn || !panel || toggleBtn.dataset.searchBound) return;
        toggleBtn.dataset.searchBound = '1';

        function openPanel() {
            panel.classList.add('is-open');
            panel.setAttribute('aria-hidden', 'false');
            toggleBtn.setAttribute('aria-expanded', 'true');

            // Foca o input após a animação abrir
            setTimeout(function () {
                var input = panel.querySelector('input[type="search"]');
                if (input) input.focus();
            }, 320);
        }

        function closePanel() {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
            toggleBtn.setAttribute('aria-expanded', 'false');
            panel.classList.remove('header-search-panel--suggest');
        }

        toggleBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            panel.classList.contains('is-open') ? closePanel() : openPanel();
        });

        // Fecha ao clicar fora do header
        document.addEventListener('click', function (e) {
            var header = document.querySelector('.site-header');
            if (header && !header.contains(e.target)) {
                closePanel();
            }
        });

        // Fecha ao pressionar Escape (sugestões fecham primeiro)
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            if (terraforteCloseSearchSuggestIfOpen()) return;
            closePanel();
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initHeaderSearchSuggest();
        initMobileSearch();
    });

    // ─── Drawer de navegação mobile ───────────────────────────────────────────

    function initMobileNav() {
        var toggleBtn = document.getElementById('hdr-menu-toggle');
        var closeBtn  = document.getElementById('mobile-nav-close');
        var drawer    = document.getElementById('mobile-nav-drawer');
        var overlay   = document.getElementById('mobile-nav-overlay');

        if (!toggleBtn || !drawer || toggleBtn.dataset.navBound) return;
        toggleBtn.dataset.navBound = '1';

        function openDrawer() {
            drawer.classList.add('is-open');
            overlay.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            overlay.setAttribute('aria-hidden', 'false');
            toggleBtn.setAttribute('aria-expanded', 'true');
            document.body.classList.add('drawer-open');

            // Foca o botão de fechar para acessibilidade
            if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
        }

        function closeDrawer() {
            drawer.classList.remove('is-open');
            overlay.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            overlay.setAttribute('aria-hidden', 'true');
            toggleBtn.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('drawer-open');
            toggleBtn.focus();
        }

        toggleBtn.addEventListener('click', openDrawer);

        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

        overlay.addEventListener('click', closeDrawer);

        // Fecha ao pressionar Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
                closeDrawer();
            }
        });

        // Fecha ao clicar em qualquer link dentro do drawer (navegação)
        drawer.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', closeDrawer);
        });
    }

    document.addEventListener('DOMContentLoaded', initMobileNav);

    // ─── Modal de login (visitante — header / drawer) ───────────────────────

    function initLoginModal() {
        var modal = document.getElementById('terraforte-login-modal');
        if (!modal) return;

        var triggers = document.querySelectorAll('.terraforte-login-modal-open');
        var closers = modal.querySelectorAll('[data-terraforte-login-close]');
        var returnFocusTrigger = null;

        function setTriggersExpanded(val) {
            triggers.forEach(function (t) {
                t.setAttribute('aria-expanded', val ? 'true' : 'false');
            });
        }

        function closeMobileDrawerIfOpen() {
            var closeNav = document.getElementById('mobile-nav-close');
            if (closeNav) closeNav.click();
        }

        function openModal(fromBtn) {
            returnFocusTrigger = fromBtn || null;
            closeMobileDrawerIfOpen();
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('terraforte-login-modal-open');
            setTriggersExpanded(true);

            var user = document.getElementById('terraforte-user-login');
            window.setTimeout(function () {
                if (user) user.focus();
            }, 80);

            if (window.lucide && typeof window.lucide.createIcons === 'function') {
                window.lucide.createIcons();
            }
        }

        function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('terraforte-login-modal-open');
            setTriggersExpanded(false);

            var t = returnFocusTrigger;
            returnFocusTrigger = null;
            if (t && typeof t.focus === 'function') {
                window.setTimeout(function () {
                    t.focus();
                }, 0);
            }
        }

        triggers.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (modal.classList.contains('is-open')) {
                    closeModal();
                } else {
                    openModal(btn);
                }
            });
        });

        closers.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                closeModal();
            });
        });

        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape' || !modal.classList.contains('is-open')) return;
            e.preventDefault();
            e.stopPropagation();
            closeModal();
        }, true);
    }

    document.addEventListener('DOMContentLoaded', initLoginModal);

})();
